import React from 'react';
import PatientEducationVideos from './PatientEducationVideos';

const PatientEducation: React.FC = () => {
  return (
    <PatientEducationVideos />
  );
};

export default PatientEducation;